import React from "react";
// Bootstrap and jQuery libraries
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
// Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import ReactDatatable from "@ashvin27/react-datatable";
import { Container, Row, Col, Card, CardBody, Button} from "shards-react";
import PageTitle from "../../components/common/PageTitle";
import { Language, API_URL, LIMIT } from "../../config";
import Select from "react-select";
import { strings } from "../../localization/Subscriptions";
import { Link } from "react-router-dom";

class Subscriptions extends React.Component {
  state = {
    records: [],
    loading: true,
    total: 0,
    skip: 0,
    limit: LIMIT,
    currentPage: 1,
    prev: true,
    next: false,
    organisations: [],
    plans: [],
    statusOptions: [],
    selectedOrganisation: null,
    selectedPlan: null,
    selectedStatus: null,
  };

  constructor(props) {
    super(props);
    strings.setLanguage(Language);

    this.state.statusOptions = [
      { value: "active", label: strings.active },
      { value: "expired", label: strings.expired }
    ];

    this.columns = [
      {
        key: "rutNumber",
        text: strings.rut_number,
      },
      // {
      //   key: "organisationCode",
      //   text: strings.org_code,
      // },
      {
        key: "organisationName",
        text: strings.org_name,
      },
      {
        key: "planName",
        text: strings.plan,
      },
      {
        key: "amount",
        text: strings.amount,
      },
      {
        key: "paymentMode",
        text: strings.payment_mode,
      },
      {
        key: "startDate",
        text: strings.start_date,
        cell: record => record.startDate ? new Date(record.startDate).toLocaleDateString() : "-"
      },
      {
        key: "endDate",
        text: strings.end_date,
        cell: record => record.endDate ? new Date(record.endDate).toLocaleDateString() : "-"
      },
      {
        key: "status",
        text: strings.status,
        cell: record => `${record.status || "-"}`
      },
      {
        key: "action",
        text: strings.action,
        sortable: false,
        cell: record => {
          return (
            <div className="mt-2">
              <Link
                to={`/subscription-history/${record.organisationId}`}
              >
                <Button size="sm" theme="success" className="mb-2 mr-1">
                  {strings.view_details || "View Details"}
                </Button>
              </Link>
            </div>
          );
        }
      }
    ];

    this.config = {
      show_pagination: false,
      show_info: false
    };
  }

  componentDidMount() {
    this.getData();
    this.getFilterData();
  }

  getFilterData = () => {
    // Fetch organisations for filter
    fetch(`${API_URL}organisations`, {
      method: "GET",
      credentials: "include"
    })
      .then(res => res.json())
      .then(res => {
        if (res.result) {
          const orgs = res.result.map(item => ({
            value: item._id,
            label: item.data.name
          }));
          this.setState({ organisations: orgs });
        }
      });

    // Fetch plans for filter
    fetch(`${API_URL}plans`, {
      method: "GET",
      credentials: "include"
    })
      .then(res => res.json())
      .then(res => {
        if (res.result) {
          const plans = res.result.map(item => ({
            value: item._id,
            label: item.data.displayName
          }));
          this.setState({ plans: plans });
        }
      });
  }

  getData = (skip = 0) => {
    this.setState({ loading: true });

    let params = `?limit=${this.state.limit}&skip=${skip}`;
    if (this.state.selectedOrganisation) {
      params += `&organisation_id=${this.state.selectedOrganisation.value}`;
    }
    if (this.state.selectedPlan) {
      params += `&plan_id=${this.state.selectedPlan.value}`;
    }
    if (this.state.selectedStatus) {
      params += `&status=${this.state.selectedStatus.value}`;
    }

    // Fetch organisations with their plan details
    fetch(`${API_URL}organisations/plans${params}`, {
      method: "GET",
      credentials: "include"
    })
      .then(res => res.json())
      .then(res => {
        if (res.result && res.result.length > 0) {

          let records = res.result.map((item) => ({
            id: item._id,
            organisationId: item.data.organisationId || "-",
            rutNumber: item.data.rutNumber || "-",
            // organisationCode: item.data.organisationCode || "-",
            organisationName:
              item.data.organisationName || item.data.name || "-",
            planName: item.data.planName || "-",
            amount: item.data.amount || "0",
            paymentMode: item.data.paymentMode || "-",
            startDate: item.data.planStartDate || null,
            endDate: item.data.planEndDate || null,
            status: item.data.status || "",
          }));

          this.setState({
            records: records,
            loading: false,
            next: res.result.length < this.state.limit
          });
        } else {
          this.setState({
            records: [],
            loading: false,
            next: true
          });
        }
      })
      .catch(err => {
        console.error("Error fetching data:", err);
        this.setState({ loading: false });
      });
  };

  handleOrganisationChange = (selectedOrganisation) => {
    this.setState({ selectedOrganisation }, () => this.getData(0));
  };

  handlePlanChange = (selectedPlan) => {
    this.setState({ selectedPlan }, () => this.getData(0));
  };

  handleStatusChange = (selectedStatus) => {
    this.setState({ selectedStatus }, () => this.getData(0));
  };

  pageIncrement = () => {
    if (!this.state.next) {
      let skip = this.state.currentPage * this.state.limit;
      this.getData(skip);
      this.setState({
        currentPage: this.state.currentPage + 1,
        prev: false,
        skip: skip
      });
    }
  }

  pageDecrement = () => {
    if (this.state.skip > 0) {
      let skip = this.state.skip - this.state.limit;
      this.getData(skip);
      this.setState({
        currentPage: this.state.currentPage - 1,
        prev: skip === 0,
        next: false,
        skip: skip
      });
    }
  }

  render() {
    return (
      <Container fluid className="main-content-container px-4">
        <Row noGutters className="page-header py-4">
          <PageTitle
            sm="4"
            title={strings.title}
            subtitle={strings.subtitle}
            className="text-sm-left"
          />
        </Row>

        <Row className="mb-4">
          <Col md="4">
            <Card small>
              <CardBody>
                <label>{strings.filter_org}</label>
                <Select
                  value={this.state.selectedOrganisation}
                  onChange={this.handleOrganisationChange}
                  options={this.state.organisations}
                  isClearable
                  placeholder={strings.select_org}
                />
              </CardBody>
            </Card>
          </Col>
          <Col md="4">
            <Card small>
              <CardBody>
                <label>{strings.filter_plan}</label>
                <Select
                  value={this.state.selectedPlan}
                  onChange={this.handlePlanChange}
                  options={this.state.plans}
                  isClearable
                  placeholder={strings.select_plan}
                />
              </CardBody>
            </Card>
          </Col>
          <Col md="4">
            <Card small>
              <CardBody>
                <label>{strings.filter_status}</label>
                <Select
                  value={this.state.selectedStatus}
                  onChange={this.handleStatusChange}
                  options={this.state.statusOptions}
                  isClearable
                  placeholder={strings.select_status}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col>
            <Card small className="mb-4">
              <CardBody className="p-3 pb-3">
                <div className="MainDiv">
                  <div className="table-responsive">
                    <ReactDatatable
                      config={this.config}
                      records={this.state.records}
                      columns={this.columns}
                      loading={this.state.loading}
                    />
                    <nav className="d-flex justify-content-center align-items-center">
                      <ul className="pagination">
                        <li className="page-item">
                          <a
                            className="page-link"
                            href="javascript:;"
                            onClick={() => this.pageDecrement()}
                            style={
                              this.state.prev
                                ? { cursor: "not-allowed", color: "gray" }
                                : null
                            }
                          >
                            {strings.previous}
                          </a>
                        </li>
                        <li className="page-item">
                          <a
                            className="page-link"
                            href="javascript:;"
                            onClick={() => this.pageIncrement()}
                            style={
                              this.state.next
                                ? { cursor: "not-allowed", color: "gray" }
                                : null
                            }
                          >
                            {strings.next}
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Subscriptions;
